<template>
  <el-card shadow="always">
    <el-form ref="ruleForm" label-position="top">
      <el-row type="flex" justify="center">
        <UploadComponent label="Importação de planilha" @uploaded="uploaded"/>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <ul style="font-size: 12px;">
            <li>Faça o download do <a href="/img/modulo-calculador.csv">template</a></li>
            <li>Preencha a planilha com as informações necessárias</li>
            <li>Suba o arquivo no nosso site</li>
          </ul>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" v-if="filename">
        <el-col :span="24">
          <el-tag>Arquivo: {{ filename }}. Linhas: {{ tableData.length }}</el-tag>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center" class="actionWrapper"  v-if="filename">
        <el-button type="primary" autofocus @click="submitForm" >{{ $t("calcular")
          }}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import UploadComponent from '../../../components/UploadComponent.vue';
import { ValuesPrepostService } from "@/services/customers/values.prepost.services";

export default {
  name: 'CalculateUpload',
  props: ['userType', 'customer'],
  data() {
    return {
      tableData: [],
      filename: '',
    };
  },
  mounted() {
    localStorage.removeItem("QUOTATION_LIST");
  },
  methods: {
    submitForm() {
      const vm = this;
/*      if (vm.usertype === '1' && !vm.customer) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: 'Informe um cliente para realizar a cotação',
        });
      }*/
      const loading = vm.$loading(vm.$options.loading);
      ValuesPrepostService.upload(vm.customer, vm.tableData)
        .then((response) => {
          localStorage.setItem("QUOTATION_LIST", JSON.stringify(response));
          this.$router.replace({ name: 'calculadora.frete.resultado',  });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    uploaded(name, data) {
      const vm = this;
      vm.tableData = data;
      vm.filename = name;
    }
  },
  components: { UploadComponent }
}
</script>
